export enum  Dias {
  Trinta = '30',
  Noventa = '90',
  CentoOitenta = '180',
  Todos = 'Todos',
}
